<style scoped>
.progress >>> .vue-simple-progress {
  justify-content: flex-start !important;
  width: 90% !important;
}
</style>

<template>
  <div class="item transfer"
  role="button"
  tabindex="0"
  draggable="false"
  :data-dir="isDir"
  :aria-label="name"
  :aria-selected="isSelected">
    <button @click="deleteItem">
      <x-icon size="1.5x" class="custom-class"></x-icon>
    </button>
    <div :id="name">
      <img class="material-icons" :src="icon">
    </div>

    <div>
      <p class="transfername">{{ name }}</p>
      <p v-if="isDir" class="size" data-order="-1">&mdash;</p>
      <p v-else class="size" :data-order="humanSize(this.size)">{{ humanSize(this.size) }}</p>
      <div v-if="isActive && !isMobile()" class="progress completed">
        <span>{{ humanSize(this.size*progress/100) }} de {{ humanSize(this.size) }} ({{ progress.toFixed(1) }}%)</span>
        <p><progress-bar size="medium" :val="progress"></progress-bar></p>
      </div>
      <div v-else-if="isActive && isMobile()" class="progress completed">
        <progress-circle :completed-steps="parseInt(progress.toFixed(0))" :total-steps="totalSteps" :diameter="diameter" circle-color="#bdbdbd" start-color="var(--blue)" stop-color="var(--blue)" :circle-width="circleWidth"></progress-circle>
      </div>
      <div v-else-if="!isActive" class="progress">
        <check-circle-icon v-if="showIcon" size="1.2x" class="custom-class"></check-circle-icon>
        <p v-if="!isMobile()" class="status">{{ statusString() }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
import filesize from 'filesize';
import moment from 'moment';
import ProgressBar from 'vue-simple-progress';
import { ProgressCircle } from 'vue-progress-circle';
import { CheckCircleIcon, XIcon } from 'vue-feather-icons';

export default {
  name: 'item',
  data: function () {
    return {
      timer: 0,
      totalSteps: 100,
      diameter: 23,
      circleWidth: 4,
    };
  },
  components: {
    ProgressBar,
    CheckCircleIcon,
    XIcon,
    ProgressCircle
  },
  props: ['progress', 'name', 'isDir', 'url', 'type', 'size', 'modified', 'index', 'status', 'errorCode', 'handle', 'completed', 'tag'],
  computed: {
    ...mapState(['selected', 'req']),
    ...mapGetters(['selectedCount']),
    isSelected () {
      return (this.selected.indexOf(this.index) !== -1);
    },
    isActive: function () {
      return (this.status === Module.TransferStatus.ACTIVE.value);
    },
    icon () {
      if (this.type === 'image') {
        let thumbnailName = '///thumbnails/' + this.handle;
          if (!window.gRequestedThumbnails.has(thumbnailName))
          {
            let uri = Module.getObjectURL(thumbnailName);
            if (uri)
            {
              let name = this.name;
              setTimeout(function() { 
                let holder = document.getElementById(name);
                if (holder) {
                  holder.style.width = '35px';
                  holder.style.height = '35px';
                  holder.style.marginLeft = '10px';
                  holder.style.marginRight = '15px';
                  holder.innerHTML='<img src="' + uri + '" width=40px; />';
                }
              }, 0);
            }
            else
            {
              window.gRequestedThumbnails.add(thumbnailName);
              let promise = ibb.downloadMetadata(this.handle, Module.MetadataType.META_THUMBNAIL.value, thumbnailName);
              promise.then(function(action) {
                if (!action.error.type)
                {
                  window.gRequestedThumbnails.delete(thumbnailName);
                  let uri = Module.getObjectURL(thumbnailName);
                  let holder = document.getElementById(action.node.name);
                  if (holder) {
                    holder.style.width = '35px';
                    holder.style.height = '35px';
                    holder.style.marginLeft = '10px';
                    holder.style.marginRight = '15px';
                    holder.innerHTML='<img src="' + uri + '" width=40px; height=40px; />';
                  }
                }
              });
            }
          }
          else {
            console.log('Thumbnail already requested');
          }
          return '/img/icons/WEBCLIENT_MimeTypes/ibbImage.svg';
      }
      if (this.type === 'audio') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbAudio.svg';
      }
      if (this.type === 'video') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbVideo.svg';
      } 
      if (this.type === 'folder') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbFolder.svg';
      }
      if (this.type === 'txt') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbTxt.svg';
      }
      if (this.type === 'pdf') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbPDF.svg';
      }
      if (this.type === 'zip') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbZIP.svg';
      }
      return '/img/icons/WEBCLIENT_MimeTypes/ibbFile.png';
    },
    showIcon () {
      if (this.errorCode == Module.ErrorType.E_SUCCESS.value) {
        return true;
      } else if (this.errorCode == Module.ErrorType.E_CANCELLED.value) {
        return false;
      }
      return false;
    }
  },
  mounted () {
  },
  methods: {
    ...mapMutations(['addSelected', 'removeSelected', 'resetSelected']),
    humanSize: function (size) {
      return filesize(size);
    },
    humanTime: function () {
      return moment(this.modified).fromNow();
    },
    deleteItem: async function () {
      if (this.status === Module.TransferStatus.FINISHED.value) {
        try {
          let action = await ibb.clearFinishedTransferByTag(this.tag);
          if (action.error.type) {
            throw new Error('Error clear finished transfer by tag: ' +  action.error.type);
          }
          this.$store.commit('setReload', true);
        } catch (e) {
          this.$showError(e);
        }
      } else {
        try {
          let action = await ibb.cancelTransferByTag(this.tag);
          if (action.error.type) {
            throw new Error('Error canceling transfer by tag: ' +  action.error.type);
          }
        } catch (e) {
          this.$showError(e);
        }
      }
    },
    statusString: function () {
      switch (this.status)
      {
        case Module.TransferStatus.QUEUED.value:
          return this.$t('transfers.queued');
        case Module.TransferStatus.RETRYING.value:
          return this.$t('transfers.retrying');
        case Module.TransferStatus.ACTIVE.value:
          return this.$t('transfers.active');
        case Module.TransferStatus.FINISHED.value:
        {
          if (this.errorCode == Module.ErrorType.E_SUCCESS.value)
          {
            return this.$t('transfers.completed');
          }
          else if (this.errorCode == Module.ErrorType.E_CANCELLED.value)
          {
            return this.$t('transfers.cancelled');
          }
          else
          {
            return this.$t('transfers.failed');
          }
        }
      }

      return '';
    },
    isMobile: function () {
      return window.innerWidth <= 768;
    },
  }
};
</script>
